export const UNKNOWN_ERROR = 30;
export const COMMAND_TIMEOUT = 31;
export const DEVICE_DISCONNECTED = 32;
